export const EVENT_OPEN_DAILY_REWARD_MODAL = "OPEN_DAILY_REWARD_MODAL";
export const EVENT_DAILY_REWARD_MODAL_OPENED = "DAILY_REWARD_MODAL_OPENED";
export const EVENT_DAILY_REWARD_MODAL_CLOSED = "DAILY_REWARD_MODAL_CLOSED";
